<template>
	<div class="flex flex-col gap-4">
		<div v-if="section == 'termen'" class="bg-white p-4">
			<div class="flex justify-between items-center mb-4">
				<h6 class="text-lg uppercase tracking-wider text-gray-500">
					Lucrari - data montaj maxima
				</h6>
			</div>
			<p class="text-sm text-gray-600 mb-4">
				Termenul pana la care trebuie facut montajul: data contractului + termenul de executie din oferta.
				Zilele de mai jos se folosesc doar pentru o oferta fara termen de executie.
			</p>
			<v-form ref="deadlineForm" class="max-w-md">
				<v-text-field v-model.number="form.deadline_days" type="number" label="Zile implicite"
					:rules="[(v) => (v >= 1 && v <= 365) || 'Intre 1 si 365']" outlined
					:disabled="!settings"></v-text-field>
			</v-form>
		</div>

		<div v-if="section == 'program'" class="bg-white p-4">
			<div class="flex justify-between items-center mb-4">
				<h6 class="text-lg uppercase tracking-wider text-gray-500">
					Program de lucru productie
				</h6>
			</div>
			<p class="text-sm text-gray-600 mb-4">
				Productia se programeaza in ore lucrate; sfarsitul unei lucrari se calculeaza dupa acest program.
				Programarile existente nu se recalculeaza.
			</p>
			<v-form ref="scheduleForm" class="max-w-md">
				<div class="grid grid-cols-2 gap-x-4">
					<v-text-field v-model="form.work_day_start" type="time" step="1800" label="Ora inceput" outlined
						:rules="[required]" :disabled="!settings"></v-text-field>
					<v-text-field v-model="form.work_day_end" type="time" step="1800" label="Ora sfarsit" outlined
						:rules="[required, endAfterStart]" :disabled="!settings"></v-text-field>
				</div>
				<div class="flex flex-row flex-wrap gap-x-4">
					<v-checkbox v-for="d in weekDays" :key="d.value" v-model="form.work_days" :value="d.value"
						:label="d.text" class="mt-0" hide-details :disabled="!settings"></v-checkbox>
				</div>
				<p v-if="!form.work_days.length" class="error--text text-sm mt-2">Alegeti cel putin o zi.</p>
			</v-form>
		</div>

		<div>
			<v-btn color="teal" class="uppercase" dark :loading="saving" :disabled="!settings || !changed" @click="save">
				Salveaza
			</v-btn>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: "SetariLucrari",
	props: {
		// Which card to show - "termen" (montage deadline) or "program" (production work schedule).
		// Save always sends the whole form, so the hidden card's fields keep their saved values.
		section: { type: String, default: "termen" },
	},
	data() {
		return {
			form: {
				deadline_days: 60,
				work_day_start: "08:00",
				work_day_end: "16:30",
				work_days: [1, 2, 3, 4, 5, 6, 7],
			},
			saving: false,
			weekDays: [
				{ text: "Luni", value: 1 },
				{ text: "Marti", value: 2 },
				{ text: "Miercuri", value: 3 },
				{ text: "Joi", value: 4 },
				{ text: "Vineri", value: 5 },
				{ text: "Sambata", value: 6 },
				{ text: "Duminica", value: 7 },
			],
		};
	},
	computed: {
		...mapState("works", ["settings"]),
		saved() {
			const s = this.settings || {};
			return {
				deadline_days: Number(s.deadline_days),
				work_day_start: (s.work_day_start || "08:00").substr(0, 5),
				work_day_end: (s.work_day_end || "16:30").substr(0, 5),
				work_days: String(s.work_days || "1,2,3,4,5,6,7").split(",").map(Number),
			};
		},
		changed() {
			const f = this.form;
			const s = this.saved;
			return (
				Number(f.deadline_days) !== s.deadline_days ||
				f.work_day_start !== s.work_day_start ||
				f.work_day_end !== s.work_day_end ||
				[...f.work_days].sort().join() !== [...s.work_days].sort().join()
			);
		},
	},
	watch: {
		settings: {
			handler(settings) {
				if (settings) {
					this.form = { ...this.saved, work_days: [...this.saved.work_days] };
				}
			},
			immediate: true,
		},
	},
	methods: {
		required(v) {
			return !!v || "Obligatoriu";
		},
		endAfterStart() {
			return this.form.work_day_end > this.form.work_day_start || "Dupa ora de inceput";
		},
		async save() {
			const form = this.section == "program" ? this.$refs.scheduleForm : this.$refs.deadlineForm;
			if (!form.validate()) return;
			if (this.section == "program" && !this.form.work_days.length) return;
			this.saving = true;
			await this.$store
				.dispatch("works/updateSettings", { ...this.form, work_days: [...this.form.work_days].sort().join(",") })
				.catch(() => {});
			this.saving = false;
		},
	},
	created() {
		this.$store.dispatch("works/fetchSettings", { force: true }).catch(() => {});
	},
};
</script>
